import { SidebarGroup } from '@app/helpers';

import {
    ACTION_SET_EMAIL_PREFERENCES_IS_OPEN,
    ACTION_SET_MOBILE_SHARE_MODAL_IS_OPEN,
    ACTION_SET_MOBILE_SIDEBAR_IS_OPEN,
    ACTION_SET_MOBILE_TRANSFER_MODAL_IS_OPEN,
    ACTION_SET_MOBILE_USER_NAVIGATION_IS_OPEN,
    ACTION_SET_NEW_VERSION_AVAILABLE,
    ACTION_SET_SIDEBAR_GROUPS,
    ACTION_SET_SIDEBAR_IS_EXPANDED,
    ACTION_SET_TWITTER_CONNECT_IS_OPEN,
    ACTION_SET_YAT_REDIRECT_MODAL_IS_OPEN,
    type DashboardActionTypes,
    type DashboardState,
} from '../types/dashboard';

const DEFAULT: DashboardState = {
    sidebar: new SidebarGroup({ children: [] }),
    sidebarIsExpanded: false,
    mobileSidebarIsOpen: false,
    mobileUserNavigationIsOpen: false,
    mobileShareModalIsOpen: false,
    mobileTransferModalIsOpen: false,
    newVersionAvailable: false,
    yatRedirectModalIsOpen: false,
    twitterConnectIsOpen: false,
    emailPreferencesIsOpen: false,
};

export function dashboard(state: DashboardState = DEFAULT, action: DashboardActionTypes) {
    switch (action.type) {
        case ACTION_SET_NEW_VERSION_AVAILABLE:
            return { ...state, newVersionAvailable: action.refresh };
        case ACTION_SET_SIDEBAR_GROUPS:
            return { ...state, sidebar: action.sidebarGroups };
        case ACTION_SET_SIDEBAR_IS_EXPANDED:
            return { ...state, sidebarIsExpanded: action.sidebarIsExpanded };
        case ACTION_SET_MOBILE_SIDEBAR_IS_OPEN:
            return { ...state, mobileSidebarIsOpen: action.mobileSidebarIsOpen };
        case ACTION_SET_MOBILE_USER_NAVIGATION_IS_OPEN:
            return { ...state, mobileUserNavigationIsOpen: action.mobileUserNavigationIsOpen };
        case ACTION_SET_MOBILE_SHARE_MODAL_IS_OPEN:
            return { ...state, mobileShareModalIsOpen: action.mobileShareModalIsOpen };
        case ACTION_SET_YAT_REDIRECT_MODAL_IS_OPEN:
            return { ...state, yatRedirectModalIsOpen: action.yatRedirectModalIsOpen };
        case ACTION_SET_MOBILE_TRANSFER_MODAL_IS_OPEN:
            return { ...state, mobileTransferModalIsOpen: action.mobileTransferModalIsOpen };
        case ACTION_SET_TWITTER_CONNECT_IS_OPEN:
            return { ...state, twitterConnectIsOpen: action.twitterConnectIsOpen };
        case ACTION_SET_EMAIL_PREFERENCES_IS_OPEN:
            return { ...state, emailPreferencesIsOpen: action.emailPreferencesIsOpen };

        default: {
            return { ...state };
        }
    }
}
